import AffiliateTripaneer from 'screens/AffiliateTripaneer'

const TeacherTraining = () => {
  return <AffiliateTripaneer type="teacher-training" />
}

export default TeacherTraining
